import BattleBatchAttacks from '~/components/war/battle/BattleBatchAttacks';
import BattleBye from '~/components/war/battle/BattleByes';
import { useGameContext } from '~/contextProviders/GameContextProvider';
import { useGetAccount } from '~/hooks/web3/useGetAccount';
import { generateMatchups } from '~/utils/utils';

import BattleMatchup from './BattleMatchup';
import BattleRulesButton from './BattleRulesButton';

export default function BattleMatchupsList() {
  const { isLoading, ownerPairings, byesByOwner } = useGameContext();
  const { data: connectedAccount } = useGetAccount();
  let matchups = [];
  if (ownerPairings && !!ownerPairings.length && connectedAccount?.address) {
    matchups = generateMatchups(connectedAccount?.address, ownerPairings);
  }
  return (
    <div className="war__container">
      {isLoading && <div className="battle-matchups--loading">Loading...</div>}
      {matchups && Boolean(matchups.length) && <BattleBatchAttacks /> }
      {matchups &&
        Boolean(matchups.length) &&
        matchups?.map((matchup: any, index) => {
          const ownerWarriorId = matchup.ownerWarriorId;
          const opponentWarriorId = matchup.opponentWarriorId;
          if (!ownerWarriorId || !opponentWarriorId) {
            return <span key={index}></span>;
          }
          return (
            <BattleMatchup
              key={`${ownerWarriorId}-matchup-${index}`}
              ownerWarriorId={ownerWarriorId}
              opponentWarriorId={opponentWarriorId}
            />
          );
        })}
      {byesByOwner &&
        !!byesByOwner.length &&
        byesByOwner?.map((byeWarriorId, index) => {
          return (
            <BattleBye
              key={`${byeWarriorId}-bye-${index}`}
              ownerWarriorId={byeWarriorId}
            />
          );
        })}
      <BattleRulesButton />
    </div>
  );
}
